import * as React from 'react';
import { useTheme } from '../../../theme';
const SummaryHeader = ({ children }) => {
    const theme = useTheme('PaymentForm').Summary;
    return React.createElement("div", { className: theme.header }, children);
};
export default SummaryHeader;
